import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import * as styles from './index.module.css'
import CloseButton from '../../../assets/images/close.svg'

const DownloadAlertBar = ({ alert, isHidden }) => {
  const [hide, setHide] = useState(true)

  const handleClick = () => {
    setHide(!hide)
  }
  useEffect(() => {
    setHide(isHidden)
  }, [isHidden])

  return (
    <div className={`${hide ? styles.hidden : ''} ${styles.container}`}>
      <span className={styles.alertMessage}>{alert}</span>
      <CloseButton className={styles.closeButton} onClick={handleClick} />
    </div>
  )
}

DownloadAlertBar.propTypes = {
  alert: PropTypes.object.isRequired,
  isHidden: PropTypes.bool,
}

DownloadAlertBar.defaultProps = {
  isHidden: false,
}

export default DownloadAlertBar
